import { required } from 'utilities';
import { OOHDisplayTypeField } from './OOHDispalyTypeField';
import { DecimalField, IntField, TextField, useField } from '@ff-it/form';
import { OOHDisplayType } from './types';

function DynamicFields({ name = '' }: { name?: string }) {
  const {
    input: { value },
  } = useField<OOHDisplayType | null>(`${name}display_type`, { allowNull: true, subscription: { value: true } });

  if (value !== 'DIGITAL' && value !== 'HYBRID') {
    return null;
  }
  const fieldClass = 'col-6';
  return (
    <div className="form-row">
      <IntField name={`${name}loop_length_sec`} label="Loop length (sec.)" className={fieldClass} />
      <IntField name={`${name}spot_length_sec`} label="Spot length (sec.)" className={fieldClass} />
      <IntField name={`${name}spots_per_loop`} label="Spots per loop" className={fieldClass} />
    </div>
  );
}

export function OOHFormatForm({ name = '' }: { name?: string }) {
  const half = 'col-6';
  const wide = 'col-12';
  return (
    <>
      <div className="form-row">
        <OOHDisplayTypeField
          name={`${name}display_type`}
          label="Display type"
          className={half}
          required
          validate={required}
        />
        <IntField name={`${name}quantity`} label="Quantity (faces)" className={half} />
        <TextField name={`${name}dimensions`} label="Dimensions (WxH)" className={half} />
        <TextField name={`${name}area`} label="Area of surface" className={half} />
      </div>
      <div className="form-row">
        <TextField name={`${name}url`} label="URL" className={wide} />
        <TextField
          name={`${name}market_dma`}
          label="Market DMA"
          className={half}
          help="Designated market area or city"
        />
        <TextField
          name={`${name}audience_data`}
          label="Audience data"
          className={half}
          help="Est. imp. per unit (e.g., weekly), reach etc."
        />
      </div>
      <div className="form-row">
        <DecimalField name={`${name}lat`} label="Latitude" className={half} />
        <DecimalField name={`${name}lon`} label="Longitude" className={half} />
      </div>
      <DynamicFields name={name} />
    </>
  );
}
